import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import Dimmer from "../components/equipments/Dimmer";
import FanCoil from "../components/equipments/FanCoil";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const FanCoilPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "فن کویل",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <FanCoil />
          <RoomEquipmentsList />
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default FanCoilPage;
